var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheckComplete = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "check_complete_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 66 66",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".check_complete_svg__cls-1{fill:#fff}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "check_complete_svg__cls-1",
    d: "M39.59 18.39a1 1 0 01-.4-.09 16.77 16.77 0 00-2.93-1 1 1 0 11.44-1.95 18.26 18.26 0 013.3 1.1 1 1 0 01-.41 1.91z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "check_complete_svg__cls-1",
    d: "M32.69 51.07a18.07 18.07 0 01-11.12-32.31 18.07 18.07 0 0115.13-3.38 1 1 0 01-.44 1.95 16.48 16.48 0 00-3.57-.4A16.08 16.08 0 0016.62 33a16.07 16.07 0 1032.13 0v-1.22a1 1 0 112-.15V33a18.09 18.09 0 01-18.06 18.07z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "check_complete_svg__cls-1",
    d: "M33.12 37.48a1 1 0 01-.71-.29L27 31.81a1 1 0 011.42-1.42l4.67 4.67 16.58-16.55a1 1 0 111.42 1.42L33.83 37.19a1 1 0 01-.71.29z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheckComplete);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/check_complete.a0f41d066fe9f789c79aee04ec015100.svg";